/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataFeedbackItemResVo } from './PageDataFeedbackItemResVo';
import {
    PageDataFeedbackItemResVoFromJSON,
    PageDataFeedbackItemResVoFromJSONTyped,
    PageDataFeedbackItemResVoToJSON,
    PageDataFeedbackItemResVoToJSONTyped,
} from './PageDataFeedbackItemResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataFeedbackItemResVo
 */
export interface ResponsePageDataFeedbackItemResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataFeedbackItemResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataFeedbackItemResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataFeedbackItemResVo}
     * @memberof ResponsePageDataFeedbackItemResVo
     */
    data?: PageDataFeedbackItemResVo;
}

/**
 * Check if a given object implements the ResponsePageDataFeedbackItemResVo interface.
 */
export function instanceOfResponsePageDataFeedbackItemResVo(value: object): value is ResponsePageDataFeedbackItemResVo {
    return true;
}

export function ResponsePageDataFeedbackItemResVoFromJSON(json: any): ResponsePageDataFeedbackItemResVo {
    return ResponsePageDataFeedbackItemResVoFromJSONTyped(json, false);
}

export function ResponsePageDataFeedbackItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataFeedbackItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataFeedbackItemResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataFeedbackItemResVoToJSON(json: any): ResponsePageDataFeedbackItemResVo {
    return ResponsePageDataFeedbackItemResVoToJSONTyped(json, false);
}

export function ResponsePageDataFeedbackItemResVoToJSONTyped(value?: ResponsePageDataFeedbackItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataFeedbackItemResVoToJSON(value['data']),
    };
}

